/* eslint-disable no-console */
/* eslint-disable no-nested-ternary */
/* eslint-disable no-unused-vars */
/* eslint-disable global-require */
/* eslint-disable react/prop-types */
/* eslint-disable max-len */
/* eslint-disable no-param-reassign */
/* eslint-disable react/forbid-prop-types */
/* eslint-disable no-underscore-dangle */
import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';
import MaterialTable from 'material-table';
import { FaFilePdf } from 'react-icons/fa';
import { RiFileExcel2Fill } from 'react-icons/ri';
import { Card, Typography } from '@material-ui/core';
import { Alert } from '@material-ui/lab';
import {
  getrattrapage,
  getsuccess,
  getnotrack,
} from './PDFData';
import 'jspdf-autotable';
import logo from '../../../../../shared/img/logo/logo_min.png';
import excelGen from './ExcelData';
import { excelSheetFromDataSet } from './DataUtil';
import companyServices from '../../../../../redux/services/companyServices';
import elearningDetailsServices from '../../../../../redux/services/elearningDetailsServices';
import examType1Services from '../../../../../redux/services/examType1Services';
import { Loading } from '../../../../../helpers/utils';
import groupServices from '../../../../../redux/services/groupServices';
import moduleServices from '../../../../../redux/services/moduleServices';

const Ponderation = ({ company, loaded }) => {
  const [exportDataArr, setExportData] = useState([]);
  const [companyData, setCompanyData] = useState([]);
  const [groups, setGroups] = useState([]);
  const [dataPonderation, setDataPonderation] = useState([]);
  const [isPonderation, setIsPonderation] = useState(false);
  const [loading, setLoading] = useState(true);
  // setPageTitle('Pondération');

  const JsPDF = typeof window !== 'undefined' ? require('jspdf').jsPDF : null;

  const getCompanyData = async () => {
    const companyRes = await companyServices.getCompanyDataById(company._id);
    if (companyRes) {
      if (companyRes.ponderation) {
        setIsPonderation(true);
        setLoading(false);
      }
      const newCompanyData = [];
      companyRes.semesters.forEach((semester) => {
        if (semester.ponderation) {
          setCompanyData([...companyData, semester]);
          newCompanyData.push(semester);
        }
      });
      setCompanyData(newCompanyData);
    }
  };

  const getGroupsExports = async () => {
    const exportsRes = await companyServices.getCompanyExports(company._id);
    const finalArr = [];
    if (exportsRes && exportsRes.length > 0) {
      exportsRes.forEach((value) => {
        const d = new Date('2023-08-30');
        const creation = new Date(value.created_at);
        if (creation.getTime() > d.getTime()) {
          finalArr.push({
            semester: value.semester,
            companyId: value.companyId,
            results: value.results,
            created_at: value.created_at,
          });
        }
      });
    }
    setExportData(finalArr);
  };

  const getGroupsByCompany = async () => {
    const groupsRes = await groupServices.getGroupsByCompany(company._id);
    if (groupsRes) {
      setGroups(groupsRes.idGroups);
    }
  };

  useEffect(() => {
    setLoading(true);
    getCompanyData();
    getGroupsExports();
    getGroupsByCompany();
  }, [loaded]);

  useEffect(async () => {
    if (exportDataArr.length > 0 && companyData.length > 0 && groups.length > 0) {
      const dataArr = [];
      const elearningDetailsRes = await elearningDetailsServices.getElearningDetailsByCompany({ companyId: company._id });
      // sorting arrays to get new array with results + ponderation for semesters with ponderation
      companyData.forEach((data) => {
        exportDataArr.forEach((item) => {
          if (data.semester === item.semester) {
            dataArr.push({
              ponderation: data.ponderation,
              data: item,
            });
          }
        });
      });
      // sorting dataArr to add to each student the catchUp variable if they have it for this semester
      dataArr.forEach((ponderationObj) => {
        groups.forEach((group) => {
          if (ponderationObj.data.semester === group.semester) {
            const checkForCatchUp = async (array1, array2) => {
              await Promise.all(array2.map(async (user) => {
                await Promise.all(array1.map(async (userResult) => {
                  if (user._id === userResult._id && user.catchUp && user.catchUp?.includes(ponderationObj.data.semester)) {
                    userResult.catchUp = true;
                    try {
                      const newResults = await moduleServices.globalResultsTest(user._id, user.email, group._id);
                      if (newResults) {
                        // quiz percent
                        let total = 0;
                        let quizPercent = 0;
                        newResults[0].forEach((module) => {
                          module.units.forEach((unit) => {
                            if (unit.unit.isFinalQuiz === true || unit.unit.isRise === true) {
                              total += 1;
                              if (unit.result.success || unit.result.completion) {
                                if (unit.result && unit.result.score) {
                                  quizPercent += (
                                    (unit.result.score.raw ? unit.result.score.raw : unit.result.score.score) / unit.result.score.max
                                  ) * 100;
                                } else if (unit.result.completion && unit.result.success) {
                                  quizPercent += 100;
                                }
                              }
                            }
                          });
                        });
                        quizPercent /= total;
                        // time done
                        let unitsTime = 0;
                        newResults[0].forEach((module) => {
                          module.units.forEach((unit) => {
                            if (unit.unit.time) {
                              unitsTime += unit.unit.time;
                            }
                          });
                        });
                        if (newResults[1].idletracker) {
                          unitsTime += newResults[1].idletracker;
                        }
                        // units percent
                        let successTotal = 0;
                        let max = 0;
                        let percent;
                        newResults[0].forEach((module) => {
                          let success = 0;
                          max = module.units.length;
                          module.units.forEach((unit) => {
                            if (unit.result.success === true || unit.result.completion === true) {
                              success += 1;
                              if ((unit.unit.isFinalQuiz === true && unit.verb === 'passed') || unit.unit.isRise) {
                                if (unit.result && unit.result.score) {
                                  percent = (
                                    (unit.result.score.raw / unit.result.score.max) * 100
                                  ).toFixed(1);
                                } else if (unit.result.completion && unit.result.success) {
                                  percent = 100;
                                } else {
                                  percent = 0;
                                }
                              }
                            }
                          });
                          successTotal += (success / max) * 100;
                        });
                        userResult.time = unitsTime;
                        userResult.percent = quizPercent;
                        userResult.unitsPercent = successTotal / newResults[0].length;
                      }
                    } catch (e) {
                      console.log(e);
                    }
                  }
                }));
              }));
            };
            checkForCatchUp(ponderationObj.data.results[0].userSuccess.data, group.listIdUsers);
            checkForCatchUp(ponderationObj.data.results[0].userRattrapage.data, group.listIdUsers);
            checkForCatchUp(ponderationObj.data.results[0].userNoTrackers.data, group.listIdUsers);
          }
        });
      });
      // adding exam grades for each student result from e-learning export
      if (elearningDetailsRes && elearningDetailsRes.idGroups && elearningDetailsRes.idGroups.length > 0) {
        await Promise.all(elearningDetailsRes.idGroups.map(async (group) => {
          await Promise.all(dataArr.map(async (formattedGroup) => {
            if (formattedGroup.data.semester === group.semester && group.level === 1 && group.elearning && group.elearning.elearningOptions) {
              await Promise.all(group.elearning.elearningOptions.map(async (exam) => {
                // grades for exams correctedby teachers
                if (
                  new Date(exam.examBegin) > new Date('2023-08-30')
                  && exam.results
                  && exam.results.length > 0
                  && exam.modality !== 'Sur la plateforme - Test de placement'
                  && exam.modality !== 'Sur la plateforme - Test de connaissance 60 minutes'
                  && exam.modality !== 'Sur la plateforme - Test de connaissance 90 minutes'
                ) {
                  exam.results.forEach((result) => {
                    const addGrades = (arr) => {
                      arr.forEach((user) => {
                        if (user._id === result.userId && result.grade) {
                          if (exam.catchUp) {
                            user.catchUpGrade = result.grade;
                          } else {
                            user.grade = result.grade;
                          }
                        }
                        if (exam.catchUp) {
                          user.catchUpTotal = 20;
                        }
                        user.total = 20;
                        if (exam.modality.includes('60 minutes')) {
                          if (exam.catchUp) {
                            user.catchUpTotal = 80;
                          }
                          user.total = 80;
                        }
                        if (exam.modality.includes('90 minutes')) {
                          if (exam.catchUp) {
                            user.catchUpTotal = 100;
                          }
                          user.total = 100;
                        }
                      });
                    };
                    formattedGroup.data.results.forEach((resultsPerLvl) => {
                      addGrades(resultsPerLvl.userSuccess.data);
                      addGrades(resultsPerLvl.userRattrapage.data);
                      addGrades(resultsPerLvl.userNoTrackers.data);
                    });
                  });
                  // grades for quiz
                } else if (new Date(exam.examBegin) > new Date('2023-08-30')
                  && (
                    exam.modality === 'Sur la plateforme - Test de connaissance 60 minutes'
                    || exam.modality === 'Sur la plateforme - Test de connaissance 90 minutes'
                  )
                ) {
                  await Promise.all(formattedGroup.data.results.map(async (resultsPerLvl) => {
                    const addQuizGrades = async (array) => {
                      await Promise.all(array.map(async (user) => {
                        try {
                          const resultsExamRes = await examType1Services.isExamFinished({
                            userId: user._id, examId: exam._id,
                          });
                          if (resultsExamRes) {
                            if (exam.catchUp) {
                              user.catchUpGrade = { scoreKN: resultsExamRes[0].examScores.scoreKN, scoreRC: resultsExamRes[0].examScores.scoreRC };
                              user.catchUpTotal = 100;
                            } else {
                              user.grade = { scoreKN: resultsExamRes[0].examScores.scoreKN, scoreRC: resultsExamRes[0].examScores.scoreRC };
                              user.total = 100;
                            }
                          }
                        } catch (e) {
                          // e
                        }
                      }));
                    };
                    addQuizGrades(resultsPerLvl.userSuccess.data);
                    addQuizGrades(resultsPerLvl.userRattrapage.data);
                    addQuizGrades(resultsPerLvl.userNoTrackers.data);
                  }));
                }
              }));
            }
          }));
        }));
      }
      setDataPonderation(dataArr);
      setLoading(false);
    }
  }, [exportDataArr, companyData, groups]);

  const dates = ['Janvier', 'Fevrier', 'Mars', 'Avril', 'Mai', 'Juin', 'Juillet', 'Aout', 'Septembre', 'Octobre', 'Novembre', 'Decembre'];
  const days = ['Lundi', 'Mardi', 'Mercredi', 'Jeudi', 'Vendredi', 'Samedi', 'Dimanche'];

  const FormatDate = ({ date }) => {
    if (date != null) {
      const newDate = new Date(date);
      const formatedDate = `${days[newDate.getDay() === 0 ? newDate.getDay() : newDate.getDay() - 1]} ${newDate.getDate()} ${dates[newDate.getMonth()]}`;
      return <div>{formatedDate}</div>;
    }
    return <div>/</div>;
  };

  const getNbStudents = (results) => {
    let tmpNbStudents = 0;

    tmpNbStudents += results[0].userSuccess.total;
    tmpNbStudents += results[0].userRattrapage.total;
    tmpNbStudents += results[0].userNoTrackers.total;
    tmpNbStudents += results[1].userSuccess.total;
    tmpNbStudents += results[1].userRattrapage.total;
    tmpNbStudents += results[1].userNoTrackers.total;

    return `${tmpNbStudents} ${company.isCompany ? 'stagiaires' : 'étudiants'}`;
  };

  const getData = async (dataToExport, ponderation) => {
    const {
      elearningTarget, elearningDuration, elearningAttempts, elearningDurationTarget,
    } = dataToExport.csvnotrack ? dataToExport.csvnotrack.target : {
      elearningTarget: 0, elearningDuration: 0, elearningAttempts: 0, elearningDurationTarget: 0,
    };
    const section = [];
    const exportColumns = ['Nom', 'Score quizs', 'Score exercices', 'Temps passé', `Note e-learning (/20) ${ponderation.elearning}%`, `Note examen (/20) ${ponderation.exams}%`, 'Note pondérée(20)'];
    section.push({ name: 'Résultats', method: await getsuccess(exportColumns, elearningTarget, elearningDuration * (elearningDurationTarget / 100) * 60, elearningAttempts, dataToExport, ponderation) });
    const rattrapData = await getrattrapage(exportColumns, elearningAttempts, elearningTarget, elearningDuration * (elearningDurationTarget / 100) * 60, dataToExport, ponderation);
    const notrackData = await getnotrack(exportColumns, dataToExport, ponderation);
    const finalData = [...section[0].method.body, ...rattrapData.body, ...notrackData.body];
    finalData.sort((a, b) => b[0] < a[0]);
    section[0].method.body = finalData;
    return section;
  };

  const exportPDFFile = async (dataToExport, semester, ponderation) => {
    if (JsPDF !== null) {
      const unit = 'pt';
      const size = 'A4';
      const orientation = 'landscape';
      if (!dataToExport.error) {
        const {
          elearningTarget, elearningDuration, elearningAttempts, elearningDurationTarget,
        } = dataToExport.csvnotrack ? dataToExport.csvnotrack.target : {
          elearningTarget: 0, elearningDuration: 0, elearningAttempts: 0, elearningDurationTarget: 0,
        };
        const section = await getData(dataToExport, ponderation);
        const doc = new JsPDF(orientation, unit, size);
        doc.setFontSize(15);
        const img = new Image();
        img.src = logo;
        doc.addImage(img, 'PNG', 40, 10);

        doc.text(`${company.name}, S${semester}`, 130, 45);
        doc.text(`Objectif quizs: ${elearningTarget}%, Objectif exercices: ${elearningAttempts}%, Objectif temps: ${elearningDurationTarget}% de ${elearningDuration / 60}h${(elearningDuration % 60 < 10 ? '0' : '')}${elearningDuration % 60}`, 130, 75);
        section.map((element, index) => {
          if (index === 0) {
            element.method.startY = 115;
            doc.text(element.name, 40, 90);
          } else {
            element.method.startY = 70;
            doc.text(element.name, 40, 45);
          }
          doc.autoTable(element.method);
          if (index + 1 < section.length) doc.addPage();
          return (doc);
        });
        doc.save(`Résultats ${company.name} - Semester ${semester}.pdf`);
      }
    }
  };

  const exportExcel = async (dataToExport, semester, ponderation) => {
    const {
      elearningTarget, elearningDuration, elearningAttempts, elearningDurationTarget,
    } = dataToExport.csvnotrack ? dataToExport.csvnotrack.target : {
      elearningTarget: 0, elearningDuration: 0, elearningAttempts: 0, elearningDurationTarget: 0,
    };
    if (!dataToExport.error) {
      const wb = { SheetNames: [], Sheets: {} };
      const successdata = excelGen.formatSuccessData(
        {
          success: dataToExport.userSuccess,
          rattrapage: dataToExport.userRattrapage,
          notrack: dataToExport.userNoTrackers,
        },
        elearningDuration * (elearningDurationTarget / 100),
        elearningTarget,
        elearningAttempts,
        elearningDurationTarget,
        ponderation,
      );
      successdata[0].data = successdata[0].data.sort((a, b) => {
        if (a[0].value < b[0].value) { return -1; }
        if (a[0].value > b[0].value) { return 1; }
        return 0;
      });

      const rattrapdata = excelGen.formatRattrapageData(
        {
          success: dataToExport.userSuccess,
          rattrapage: dataToExport.userRattrapage,
          notrack: dataToExport.userNoTrackers,
        },
        elearningDuration * (elearningDurationTarget / 100),
        elearningTarget,
        elearningAttempts,
        elearningDurationTarget,
        ponderation,
      );
      rattrapdata[0].data = rattrapdata[0].data.sort((a, b) => {
        if (a[0].value < b[0].value) { return -1; }
        if (a[0].value > b[0].value) { return 1; }
        return 0;
      });

      const notrackdata = excelGen.formatNoTrackData(
        {
          success: dataToExport.userSuccess,
          rattrapage: dataToExport.userRattrapage,
          notrack: dataToExport.userNoTrackers,
        },
        ponderation,
      );
      notrackdata[0].data = notrackdata[0].data.sort((a, b) => {
        if (a[0].value < b[0].value) { return -1; }
        if (a[0].value > b[0].value) { return 1; }
        return 0;
      });

      const finalArr = [{ columns: successdata[0].columns, data: [...successdata[0].data, ...rattrapdata[0].data, ...notrackdata[0].data] }];
      finalArr[0].data.sort((a, b) => b[0].value < a[0].value);
      wb.SheetNames.push('Résultats');
      wb.Sheets['Résultats'] = excelSheetFromDataSet(finalArr);

      excelGen.generateExcel(wb, `Résultats Semester ${semester} - ${new Date(dataToExport.exportData.created_at).toLocaleDateString('fr')}.xlsx`);
    }
  };

  const downloadExport = ({
    results, semester, exportData, ponderation,
  }, opt) => {
    let userNoTrackers = [];
    let userRattrapage = [];
    let userSuccess = [];
    const csvnotrack = { data: [], total: 0 };
    const csvsuccess = { data: [], total: 0 };
    const csvrattrapage = { data: [], total: 0 };

    results.forEach((val) => {
      userNoTrackers = [...userNoTrackers, ...val.userNoTrackers.data];
      userRattrapage = [...userRattrapage, ...val.userRattrapage.data];
      userSuccess = [...userSuccess, ...val.userSuccess.data];
    });
    for (let i = 0; i < userNoTrackers.length; i += 1) {
      for (let j = 0; j < userNoTrackers.length; j += 1) {
        if (userNoTrackers[i] && userNoTrackers[j]._id === userNoTrackers[i]._id && j !== i) {
          userNoTrackers.splice(i, 1);
        }
      }
      for (let j = 0; j < userRattrapage.length; j += 1) {
        if (userNoTrackers[i] && userRattrapage[j]._id === userNoTrackers[i]._id) {
          userNoTrackers.splice(i, 1);
        }
      }
      for (let j = 0; j < userSuccess.length; j += 1) {
        if (userNoTrackers[i] && userSuccess[j]._id === userNoTrackers[i]._id) {
          userNoTrackers.splice(i, 1);
        }
      }
    }
    for (let i = 0; i < userRattrapage.length; i += 1) {
      for (let j = 0; j < userSuccess.length; j += 1) {
        if (userRattrapage[i] && userSuccess[j]._id === userRattrapage[i]._id) {
          userRattrapage.splice(i, 1);
        }
      }
      for (let j = 0; j < userRattrapage.length; j += 1) {
        if (userRattrapage[i] && userRattrapage[j]._id === userRattrapage[i]._id && j !== i) {
          if (userRattrapage[i].percent > userRattrapage[j].percent) {
            userRattrapage.splice(j, 1);
          } else if (userRattrapage[j].percent === userRattrapage[i].percent && userRattrapage[i].time > userRattrapage[j].time) {
            userRattrapage.splice(j, 1);
          } else {
            userRattrapage.splice(i, 1);
          }
        }
      }
    }
    for (let i = 0; i < userSuccess.length; i += 1) {
      for (let j = 0; j < userSuccess.length; j += 1) {
        if (userSuccess[i] && userSuccess[j]._id === userSuccess[i]._id && j !== i) {
          if (userSuccess[i].percent > userSuccess[j].percent) {
            userSuccess.splice(j, 1);
          } else if (userSuccess[j].percent === userSuccess[i].percent && userSuccess[i].time > userSuccess[j].time) {
            userSuccess.splice(j, 1);
          } else {
            userSuccess.splice(i, 1);
          }
        }
      }
    }
    csvnotrack.target = results[0].csvnotrack.target;
    csvrattrapage.target = results[0].csvrattrapage.target;
    csvsuccess.target = results[0].csvsuccess.target;

    csvnotrack.data = userNoTrackers;
    csvnotrack.total = userNoTrackers.length;
    csvrattrapage.data = userRattrapage;
    csvrattrapage.total = userRattrapage.length;
    csvsuccess.data = userSuccess;
    csvsuccess.total = userSuccess.length;

    const dataToExport = ({
      csvnotrack,
      csvsuccess,
      csvrattrapage,
      userSuccess: { data: userSuccess },
      userRattrapage: { data: userRattrapage },
      userNoTrackers: { data: userNoTrackers },
      exportData,
    });
    // eslint-disable-next-line no-constant-condition
    if (opt === true) {
      exportPDFFile(dataToExport, semester, ponderation);
    } else {
      exportExcel(dataToExport, semester, ponderation);
    }
  };

  return (
    <div>
      {loading === false
        ? isPonderation
          ? (
            <>
              <MaterialTable
                title="Exports"
                columns={[
                  {
                    title: company.isCompany ? 'Parcours' : 'Semestre',
                    field: 'data.semester',
                  },
                  {
                    title: company.isCompany ? 'Nombre de stagiaires' : 'Nombre d\'étudiants',
                    field: 'results',
                    render: ({ data }) => getNbStudents(data.results),
                  },
                ]}
                data={dataPonderation}
                options={{
                  actionsColumnIndex: -1,
                }}
                localization={{
                  header: {
                    actions: 'Exports',
                  },
                  toolbar: {
                    exportCSVName: 'Exporter en Excel',
                    exportPDFName: 'Exporter en PDF',
                  },
                  body: {
                    emptyDataSourceMessage: 'Aucune données.',
                  },
                }}
                actions={[
                  {
                    icon: () => <FaFilePdf color="red" />,
                    tooltip: 'Telecharger l\'export PDF',
                    onClick: (_event, exportData) => downloadExport({
                      results: exportData.data.results,
                      semester: exportData.data.semester,
                      exportData: exportData.data,
                      ponderation: exportData.ponderation,
                    }, true),
                  },
                  {
                    icon: () => <RiFileExcel2Fill color="#228822" />,
                    tooltip: 'Telecharger l\'export Excel',
                    onClick: (_event, exportData) => downloadExport({
                      results: exportData.data.results,
                      semester: exportData.data.semester,
                      exportData: exportData.data,
                      ponderation: exportData.ponderation,
                    }, false),
                  },
                ]}
              />

            </>
          )
          : (
            <Card
              style={{
                // padding: '20px',
              }}
            >
              <Alert
                severity="info"
              >
                <Typography
                  variant="body2"
                >
                  Vous n&apos;avez pas activé la pondération.
                  Si vous désirez la mettre en place, veuillez vous rendre dans l&apos;onglet Mes informations &gt; Semestres &gt; Activer la pondération
                </Typography>
              </Alert>
            </Card>
          )
        : <Loading />}
    </div>
  );
};

Ponderation.propTypes = {
  company: PropTypes.object.isRequired,
};

function mapState(state) {
  const { company } = state.company;
  return { company };
}

const connectedPonderation = connect(mapState, {})(Ponderation);

export default withRouter(connectedPonderation);
